import styles from './Spinner.module.css';

interface SpinnerProps {
  large?: boolean;
  centered?: boolean;
}

export function Spinner({ large = false, centered = false }: SpinnerProps) {
  const spinner = (
    <span
      className={large ? styles.spinnerLarge : styles.spinner}
      role="status"
      aria-label="Lädt"
    />
  );

  if (centered) {
    return <div className={styles.center}>{spinner}</div>;
  }

  return spinner;
}
